import { SchemeTypes } from '../../../../config';
import { IIdentificationDetails } from '../../models';
export interface IdentificationDetailsFormFields {
  identificationDetails_registrationId: string | null;
  identificationDetails_username: string | null;
  identificationDetails_intermediary?: string | null;
  identificationDetails_companyName: string | null;
  identificationDetails_vatNumber: string | null;
  identificationDetails_nationalTaxRefNumber?: string | null;
  identificationDetails_vatGroup?: boolean | null;
  identificationDetails_placeOfBusiness?: string | null;
  identificationDetails_issuingCountry?: string | null;
  identificationDetails_trading_name: Array<string> | null;
}

export function handleIdentificationDetailsFormDefaultValues(
  identification_details: IIdentificationDetails
): IdentificationDetailsFormFields {
  var ossSheme = identification_details.scheme;
  var intermediary = identification_details.is_agent;
  switch (ossSheme) {
    case SchemeTypes.EU:
      return euSchemeDefaultValues(identification_details);
    case SchemeTypes.NON_EU:
      return nonEuSchemeDefaultValues(identification_details);
    default:
      if (intermediary) {
        return importSchemeIntermediaryDefaultValues(identification_details);
      } else {
        return importSchemeDefaultValues(identification_details);
      }
  }
}

function euSchemeDefaultValues(
  identification_details: IIdentificationDetails
): IdentificationDetailsFormFields {
  return {
    identificationDetails_registrationId: `${identification_details.registration_id}`,
    identificationDetails_username: identification_details.username,
    identificationDetails_companyName: identification_details.company_name,
    identificationDetails_vatNumber: identification_details.vat_num,
    identificationDetails_vatGroup:
      identification_details.vat_group == 'T' ||
      identification_details.vat_group == 'true'
        ? true
        : false,
    identificationDetails_trading_name: tradingNamesToArray(
      identification_details.trading_name
    ),
  };
}

function nonEuSchemeDefaultValues(
  identification_details: IIdentificationDetails
): IdentificationDetailsFormFields {
  console.log('test', identification_details.vat_group);
  return {
    identificationDetails_registrationId: `${identification_details.registration_id}`,
    identificationDetails_username: identification_details.username,
    identificationDetails_companyName: identification_details.company_name,
    identificationDetails_vatNumber: identification_details.vat_num,
    identificationDetails_nationalTaxRefNumber:
      identification_details.non_national_tax_ref_num,
    identificationDetails_placeOfBusiness:
      `${identification_details.non_place_of_business}` ?? null,
    identificationDetails_issuingCountry:
      `${identification_details.non_issuing_country}` ?? null,
    identificationDetails_trading_name: tradingNamesToArray(
      identification_details.trading_name
    ),
    identificationDetails_vatGroup:
      identification_details.vat_group == 'T' ||
      identification_details.vat_group == 'true'
        ? true
        : false,
  };
}

function importSchemeDefaultValues(
  identification_details: IIdentificationDetails
): IdentificationDetailsFormFields {
  return {
    identificationDetails_registrationId: `${identification_details.registration_id}`,
    identificationDetails_username: identification_details.username,
    identificationDetails_intermediary: `${identification_details.agent_vat_num}`,
    identificationDetails_companyName: identification_details.company_name,
    identificationDetails_vatNumber: identification_details.vat_num,
    identificationDetails_nationalTaxRefNumber:
      identification_details.import_national_tax_ref_num,
    identificationDetails_placeOfBusiness:
      `${identification_details.import_place_of_business}` ?? null,
    identificationDetails_issuingCountry:
      `${identification_details.import_issuing_country}` ?? null,
    identificationDetails_trading_name: tradingNamesToArray(
      identification_details.trading_name
    ),
  };
}

function importSchemeIntermediaryDefaultValues(
  identification_details: IIdentificationDetails
): IdentificationDetailsFormFields {
  return {
    identificationDetails_registrationId: `${identification_details.registration_id}`,
    identificationDetails_username: identification_details.username,
    identificationDetails_intermediary: `${identification_details.agent_vat_num}`,
    identificationDetails_companyName: identification_details.company_name,
    identificationDetails_vatNumber: identification_details.vat_num,
    identificationDetails_placeOfBusiness:
      `${identification_details.import_place_of_business}` ?? null,
    identificationDetails_issuingCountry:
      `${identification_details.import_issuing_country}` ?? null,
    identificationDetails_trading_name: tradingNamesToArray(
      identification_details.trading_name
    ),
    identificationDetails_nationalTaxRefNumber:
      identification_details.import_national_tax_ref_num ?? null,
  };
}

const tradingNamesToArray = (tradingNames: any): Array<string> => {
  let array: Array<string> = [];
  if (tradingNames)
    for (let item of tradingNames) array.push(item.trading_name);
  return array;
};
